module.exports = __webpack_public_path__ + "img/6-3.d4b87591.png";